module.exports = __webpack_public_path__ + "static/media/actions.3e7581ce.svg";